var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var EventCardDateTime = /** @class */ (function (_super) {
    __extends(EventCardDateTime, _super);
    function EventCardDateTime(props) {
        var _this = _super.call(this, props) || this;
        _this.dateTimeClasses = _this.props.baseClass + (_this.props.modifiers ? " " + _this.props.modifiers : "");
        return _this;
    }
    EventCardDateTime.prototype.render = function () {
        return (React.createElement("div", { className: this.dateTimeClasses }, this.props.content));
    };
    return EventCardDateTime;
}(React.PureComponent));
export { EventCardDateTime };
//# sourceMappingURL=EventCardDateTime.js.map